import type { RowData } from "@tanstack/react-table";
import { Table, type TableProps } from "@sellar-io/components";

export function TableInfinite<T extends RowData>({
  columns,
  data,
  initialOffset,
  setScrollOffset,
  infiniteQuery,
  onRowClick,
  noResultsText,
  gridClasses,
  gridStyles,
  columnSortName,
  handleTableSort,
  horizontalInfinite,
  roundedBottom,
  roundedTop,
}: Pick<
  TableProps<T>,
  | "columns"
  | "data"
  | "onRowClick"
  | "noResultsText"
  | "handleTableSort"
  | "columnSortName"
  | "pageCount"
  | "gridClasses"
  | "gridStyles"
  | "initialOffset"
  | "setScrollOffset"
  | "infiniteQuery"
  | "horizontalInfinite"
  | "roundedBottom"
  | "roundedTop"
>) {
  return (
    <Table
      columns={columns}
      data={data}
      infinite={true}
      infiniteQuery={infiniteQuery}
      initialOffset={initialOffset}
      setScrollOffset={setScrollOffset}
      gridClasses={gridClasses}
      gridStyles={gridStyles}
      columnSortName={columnSortName}
      handleTableSort={handleTableSort}
      onRowClick={onRowClick}
      noResultsText={noResultsText}
      horizontalInfinite={horizontalInfinite}
      roundedBottom={roundedBottom}
      roundedTop={roundedTop}
    />
  );
}
